import fetchJson, { FetchError } from '@/lib/fetchJson'
import { invalidateForWrite } from '@/lib/cacheInvalidation'
import {
    errorBodyCode,
    isSessionFailure,
    unauthorized
} from '@/lib/api/transport'

export abstract class AuthenticatedApiClient {
    constructor(
        protected readonly baseUrl: string,
        protected readonly authToken: () => string
    ) {}

    protected async fetchWithAuth<T = unknown>(
        url: string,
        options: RequestInit
    ): Promise<T> {
        try {
            const result = await fetchJson(url, {
                ...options,
                headers: {
                    Authorization: `Bearer ${this.authToken()}`,
                    'Content-Type': 'application/json',
                    ...options.headers
                }
            })
            invalidateForWrite(options.method, url)
            return result as T
        } catch (err) {
            // See transport.ts: a coded 403 stays a typed FetchError.
            if (
                err instanceof FetchError &&
                isSessionFailure(err.response.status, errorBodyCode(err.data))
            ) {
                unauthorized(url)
            }
            throw err
        }
    }
}
